import type { Route } from 'next';

import { CopyItem } from '@/components/valuePropList';
import { RouterPush } from '@/hooks/utils/useRouterPush';
import getUrl from '@/utils/getUrl';

import Account from '../../Account';
import messages from '../../Account/messages';
import { AccountScreenConfig } from '../../Account/types';
import { accountFAQ } from '../../Account/utils';
import Handoff from '../../Handoff';
import handoffMessages from '../../Handoff/messages';
import { HandoffScreenConfig } from '../../Handoff/types';
import Payment from '../../Payment';
import { PaymentScreenConfig } from '../../Payment/types';
import { spotifyValueProps } from './data';

const activeScreenSet = {
	account: Account as React.FC,
	payment: Payment as React.FC,
	handoff: Handoff as React.FC,
};

export const accountValueProps: Array<CopyItem> = [
	{
		id: 'valueProp1',
		header: messages.valueProp1Head,
		body: messages.valueProp1Body,
	},
	{
		id: 'valueProp2',
		header: messages.valueProp2Head,
		body: messages.valueProp2Body,
	},
	{
		id: 'valueProp3',
		header: messages.valueProp3Head,
		body: messages.valueProp3Body,
	},
];

const SpotifyAccountScreenConfig: AccountScreenConfig = {
	name: 'account',
	component: activeScreenSet.account,
	nextScreen: 'payment',
	upsellBullets: accountValueProps,
	upsellHeader: () => ({ message: messages.valuePropHeader }),
	FAQs: accountFAQ(messages, 7),
	hasPremiumSubCallback: (routerPush: RouterPush) => {
		routerPush(`${getUrl('api')}/partnerships/spotify/link-account`);
	},
	showHeader: false,
	heading: ({ authFormMode }) => {
		if (authFormMode === 'login') {
			return { message: messages.loginFormHeading };
		} else {
			return { message: messages.signupFormHeading };
		}
	},
	limitedTimeOffer: true,
	valuePropsColor: 'white',
	valuePropsButtonColor: 'white',
};
const SpotifyPaymentScreenConfig: PaymentScreenConfig = {
	component: activeScreenSet.payment,
	name: 'payment',
	nextScreen: 'handoff',
	showHeader: true,
	upsellBullets: accountValueProps,
	heading: () => ({ message: messages.signupFormHeading }),
	showToggle: false,
	limitedTimeOffer: true,
};
const SpotifyHandoffScreenConfig: HandoffScreenConfig = {
	component: activeScreenSet.handoff,
	name: 'handoff',
	nextScreen: null,
	showHeader: true,
	images: {},
	bullets: {},
	upsellBullets: spotifyValueProps,
	userCanExit: false,
	CTA: {
		onClick: async (routerPush: RouterPush) => {
			await routerPush(`${getUrl('api')}/partnerships/spotify/link-account`);
		},
		label: handoffMessages.continueHere,
		description: handoffMessages.limitedAccessSpotify,
		href: `${getUrl('api')}/partnerships/spotify/link-account` as Route,
	},
};

export default {
	account: SpotifyAccountScreenConfig,
	payment: SpotifyPaymentScreenConfig,
	handoff: SpotifyHandoffScreenConfig,
};
